import { A6EventForm } from "./form";

export function A6EventsNew() {
  return <A6EventForm isNew />;
}
